import Caisse from '../../components/caisse/Caisse';

export default function CaisseCaissier() {
  return <Caisse role="caissier" />;
}
